import Slider from "@material-ui/core/Slider";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import React, { useEffect, useState } from "react";
import { useStateValue } from "../../Registration/Components/ContextAPI/StateProvider";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const DeviceSettingOBDLeft = ({ planid }) => {
  const [
    {
      devicesetting,
      globalalert,
      serviceProvider,
      activationType,
      servicerules,
    },
    dispatch,
  ] = useStateValue();
  const [speedvalue, setspeedvalue] = useState(devicesetting.speed_limit);
  const [tripvalue, settripvalue] = useState(devicesetting.trip_end_timer);
  const [secondarynumber, setsecondarynumber] = useState(false);

  const [harsherror, setharsherror] = useState(false);
  const [crasherror, setcrasherror] = useState(false);
  const [towingerror, settowingerror] = useState(false);
  const [secondaryerror, setsecondaryerror] = useState(false);

  const [snackbar, setsnackbar] = useState(false);
  const [snackharshbar, setsnackharshbar] = useState(false);
  const [snacktowingbar, setsnacktowingbar] = useState(false);
  const [snackcrashbar, setsnackcrashbar] = useState(false);

  useEffect(() => {
    setspeedvalue(devicesetting.speed_limit);
    settripvalue(devicesetting.trip_end_timer);
  }, [devicesetting]);

  useEffect(() => {
    /* eslint-disable react-hooks/exhaustive-deps */
    if (planid) {
      let bool = planfuncchk("allow_second_phone_number");
      let bool2 = planfuncchk("harsh_behaviour");
      let bool3 = planfuncchk("crash_detection");
      let bool4 = planfuncchk("towing_alert");
      setharsherror(bool2);
      setcrasherror(bool3);
      setsecondaryerror(bool);
      settowingerror(bool4);
    }
  }, [planid]);

  const callreducer = (val) => {
    dispatch({
      type: "ADD_TO_DEVICESETTINGS",
      devicesetting: val,
    });
  };
  const marks = [
    {
      value: 0,
      label: `0 ${activationType.unit}`,
    },
    {
      value: 300,
      label: `300 ${activationType.unit}`,
    },
  ];
  const marks2 = [
    {
      value: 0,
      label: "0 Min",
    },
    {
      value: 10,
      label: "10 Min",
      className: "shiftright",
    },
  ];

  function valuetext(value) {
    return `${value} ${activationType.unit}`;
  }
  function valuetext2(value) {
    return `${value} Min`;
  }
  const changeglobalsetting = (e) => {
    devicesetting.attach_dettach_email = e.target.checked;
    devicesetting.attach_dettach_notification = e.target.checked;
    devicesetting.attach_dettach_notification_global = e.target.checked;
    devicesetting.attach_dettach_sms = e.target.checked;
    devicesetting.engine_email = e.target.checked;
    devicesetting.engine_notification = e.target.checked;
    devicesetting.engine_notification_global = e.target.checked;
    devicesetting.engine_sms = e.target.checked;
    devicesetting.speed_email = e.target.checked;
    devicesetting.speed_notification = e.target.checked;
    devicesetting.speed_notification_global = e.target.checked;
    devicesetting.speed_sms = e.target.checked;
    if (!harsherror) {
      devicesetting.harsh_notification_global = e.target.checked;
      devicesetting.harshacceleration_email = e.target.checked;
      devicesetting.harshacceleration_notification = e.target.checked;
      devicesetting.harshacceleration_sms = e.target.checked;
      devicesetting.harshbraking_email = e.target.checked;
      devicesetting.harshbraking_notification = e.target.checked;
      devicesetting.harshbraking_sms = e.target.checked;
      devicesetting.harshturning_email = e.target.checked;
      devicesetting.harshturning_notification = e.target.checked;
      devicesetting.harshturning_sms = e.target.checked;
    }
    if (!towingerror) {
      devicesetting.tow_email = e.target.checked;
      devicesetting.tow_notification = e.target.checked;
      devicesetting.tow_notification_global = e.target.checked;
      devicesetting.tow_sms = e.target.checked;
    }
    if (!crasherror) {
      devicesetting.crash_acceleration_email = e.target.checked;
      devicesetting.crash_acceleration_notification = e.target.checked;
      devicesetting.crash_acceleration_notification_global = e.target.checked;
      devicesetting.crash_acceleration_sms = e.target.checked;
    }
    devicesetting.global_email = e.target.checked;
    devicesetting.global_notification = e.target.checked;
    devicesetting.global_sms = e.target.checked;
    callreducer(devicesetting);
    dispatch({
      type: "ADD_TO_GLOBALALERT",
      globalalert: e.target.checked,
    });
  };
  const changeglobalemail = (e) => {
    devicesetting.attach_dettach_email = e.target.checked;
    devicesetting.engine_email = e.target.checked;
    devicesetting.global_email = e.target.checked;
    devicesetting.speed_email = e.target.checked;
    if (!harsherror) {
      devicesetting.harshacceleration_email = e.target.checked;
      devicesetting.harshbraking_email = e.target.checked;
      devicesetting.harshturning_email = e.target.checked;
    }
    if (!towingerror) devicesetting.tow_email = e.target.checked;
    if (!crasherror) devicesetting.crash_acceleration_email = e.target.checked;
    callreducer(devicesetting);
  };
  const changeglobalnotification = (e) => {
    devicesetting.attach_dettach_notification = e.target.checked;
    devicesetting.engine_notification = e.target.checked;
    devicesetting.global_notification = e.target.checked;
    devicesetting.speed_notification = e.target.checked;
    if (!harsherror) {
      devicesetting.harshacceleration_notification = e.target.checked;
      devicesetting.harshbraking_notification = e.target.checked;
      devicesetting.harshturning_notification = e.target.checked;
    }
    if (!towingerror) devicesetting.tow_notification = e.target.checked;
    if (!crasherror)
      devicesetting.crash_acceleration_notification = e.target.checked;
    callreducer(devicesetting);
  };
  const changeglobalsms = (e) => {
    devicesetting.attach_dettach_sms = e.target.checked;
    devicesetting.engine_sms = e.target.checked;
    devicesetting.global_sms = e.target.checked;
    devicesetting.speed_sms = e.target.checked;
    if (!harsherror) {
      devicesetting.harshacceleration_sms = e.target.checked;
      devicesetting.harshbraking_sms = e.target.checked;
      devicesetting.harshturning_sms = e.target.checked;
    }
    if (!towingerror) devicesetting.tow_sms = e.target.checked;
    if (!crasherror) devicesetting.crash_acceleration_sms = e.target.checked;
    callreducer(devicesetting);
  };
  const changeglobalattach = (e) => {
    devicesetting.attach_dettach_email = e.target.checked;
    devicesetting.attach_dettach_notification = e.target.checked;
    devicesetting.attach_dettach_notification_global = e.target.checked;
    devicesetting.attach_dettach_sms = e.target.checked;
    callreducer(devicesetting);
  };
  const changeglobalengine = (e) => {
    devicesetting.engine_email = e.target.checked;
    devicesetting.engine_notification = e.target.checked;
    devicesetting.engine_notification_global = e.target.checked;
    devicesetting.engine_sms = e.target.checked;
    callreducer(devicesetting);
  };
  const changeglobalharsh = (e) => {
    if (harsherror) {
      setsnackharshbar(true);
      return;
    }
    devicesetting.harsh_notification_global = e.target.checked;
    devicesetting.harshacceleration_email = e.target.checked;
    devicesetting.harshacceleration_notification = e.target.checked;
    devicesetting.harshacceleration_sms = e.target.checked;
    devicesetting.harshbraking_email = e.target.checked;
    devicesetting.harshbraking_notification = e.target.checked;
    devicesetting.harshbraking_sms = e.target.checked;
    devicesetting.harshturning_email = e.target.checked;
    devicesetting.harshturning_notification = e.target.checked;
    devicesetting.harshturning_sms = e.target.checked;
    callreducer(devicesetting);
  };
  const changeglobalspeed = (e) => {
    devicesetting.speed_email = e.target.checked;
    devicesetting.speed_notification = e.target.checked;
    devicesetting.speed_notification_global = e.target.checked;
    devicesetting.speed_sms = e.target.checked;
    callreducer(devicesetting);
  };
  const changeglobalcrash = (e) => {
    if (crasherror) {
      setsnackcrashbar(true);
      return;
    }
    devicesetting.crash_acceleration_email = e.target.checked;
    devicesetting.crash_acceleration_notification = e.target.checked;
    devicesetting.crash_acceleration_sms = e.target.checked;
    devicesetting.crash_acceleration_notification_global = e.target.checked;
    callreducer(devicesetting);
  };
  const changeglobaltow = (e) => {
    if (towingerror) {
      setsnacktowingbar(true);
      return;
    }
    devicesetting.tow_email = e.target.checked;
    devicesetting.tow_notification = e.target.checked;
    devicesetting.tow_notification_global = e.target.checked;
    devicesetting.tow_sms = e.target.checked;
    callreducer(devicesetting);
  };
  const changeglobalwarning = (e) => {
    devicesetting.warning_email = e.target.checked;
    devicesetting.warning_notification = e.target.checked;
    devicesetting.warning_notification_global = e.target.checked;
    devicesetting.warning_sms = e.target.checked;
    callreducer(devicesetting);
  };
  const inputEvent = (e) => {
    const name = e.target.name;
    if (
      name === "tow_notification" ||
      name === "tow_email" ||
      name === "tow_sms"
    ) {
      if (towingerror) {
        setsnacktowingbar(true);
        return;
      }
    }
    if (
      name === "crash_acceleration_notification" ||
      name === "crash_acceleration_email" ||
      name === "crash_acceleration_sms"
    ) {
      if (crasherror) {
        setsnackcrashbar(true);
        return;
      }
    }
    if (
      name === "harshacceleration_email" ||
      name === "harshacceleration_notification" ||
      name === "harshacceleration_sms" ||
      name === "harshbraking_email" ||
      name === "harshbraking_notification" ||
      name === "harshbraking_sms" ||
      name === "harshturning_email" ||
      name === "harshturning_notification" ||
      name === "harshturning_sms"
    ) {
      if (harsherror) {
        setsnackharshbar(true);
        return;
      }
    }
    devicesetting[`${name}`] = e.target.checked;
    callreducer(devicesetting);
  };
  const inputEvent2 = (e) => {
    const name = e.target.name;
    if (name === "secondary_phone" || name === "phone") {
      if (e.target.value.length > 10 || Number.isNaN(Number(e.target.value))) {
        return;
      }
      devicesetting[`${name}`] = e.target.value.trim();
    } else {
      devicesetting[`${name}`] = e.target.value;
    }
    callreducer(devicesetting);
  };
  const handleChange = (event, newvalue) => {
    setspeedvalue(newvalue);
    devicesetting.speed_limit = newvalue;
    callreducer(devicesetting);
  };
  const handletripChange = (event, newvalue) => {
    settripvalue(newvalue);
    devicesetting.trip_end_timer = newvalue;
    callreducer(devicesetting);
  };
  const changeOdometer = (event) => {
    dispatch({
      type: "ADD_TO_ODOMETERVALUE",
      odometer_value: event.target.value,
    });
  };
  const handleharshaccelerationchange = (e) => {
    if (harsherror) {
      setsnackharshbar(true);
      return;
    }
    let id = e.target.id;
    devicesetting[id] = e.target.value;
    callreducer(devicesetting);
  };
  const handlecrashdetectionchange = (e) => {
    if (crasherror) {
      setsnackcrashbar(true);
      return;
    }
    let id = e.target.id;
    devicesetting[id] = e.target.value;
    callreducer(devicesetting);
  };
  const checksecondarynumber = () => {
    if (secondaryerror) {
      setsnackbar(true);
      return;
    }
    setsecondarynumber(true);
  };
  const planfuncchk = (type) => {
    if (servicerules[planid] && servicerules[planid]["rules"]) {
      if (servicerules[planid]["rules"].search(type) !== -1) {
        return false;
      } else {
        return true;
      }
    }
    return true;
  };
  const updateplan = () => {
    window.open(
      `https://amcrestgps.net/gps-activation/#/device-plan/update?customer_id=${devicesetting["customer_id"]}`,
      "_blank"
    );
  };
  const handlesnackbar = () => {
    setsnackbar(false);
    setsnackharshbar(false);
    setsnacktowingbar(false);
    setsnackcrashbar(false);
  };
  return (
    <div style={{ marginLeft: "50px" }}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackbar}
        autoHideDuration={6000}
        onClose={handlesnackbar}
      >
        <Alert onClose={handlesnackbar} severity="error">
          Upgrade your plan to enable secondary phone number !
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackharshbar}
        autoHideDuration={6000}
        onClose={handlesnackbar}
      >
        <Alert onClose={handlesnackbar} severity="error">
          Upgrade your plan to enable Harsh Behaviour Alert !
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snacktowingbar}
        autoHideDuration={6000}
        onClose={handlesnackbar}
      >
        <Alert onClose={handlesnackbar} severity="error">
          Upgrade your plan to enable Towing Alert !
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackcrashbar}
        autoHideDuration={6000}
        onClose={handlesnackbar}
      >
        <Alert onClose={handlesnackbar} severity="error">
          Upgrade your plan to enable Crash Detection Alert !
        </Alert>
      </Snackbar>
      <div className="devicesettingleft">
        <div className="row marginrow">
          <div className="col-md-4 textalignleft">
            <strong>IMEI:</strong>
          </div>
          <div className="col-md-8">
            <input
              value={devicesetting.imei}
              name="imei"
              type="text"
              placeholder="Device Name"
              readOnly
              className="form-control devicesettingleft_text"
            />
          </div>
        </div>
        <div className="row marginrow">
          <div className="col-md-4 textalignleft">
            <strong>Device Name:</strong>
          </div>
          <div className="col-md-8">
            <input
              value={devicesetting.device_name}
              name="device_name"
              onChange={inputEvent2}
              type="text"
              placeholder="Device Name"
              className="form-control devicesettingleft_text"
            />
          </div>
        </div>
        <div className="row marginrow">
          <div className="col-md-4 textalignleft">
            <strong>Alert Email Alerts:</strong>
          </div>
          <div className="col-md-8">
            <input
              name="email"
              value={devicesetting.email}
              onChange={inputEvent2}
              type="text"
              placeholder="Leave blank to disable"
              className="form-control devicesettingleft_text"
            />
          </div>
        </div>
        <div className="row marginrow">
          <div className="col-md-4 textalignleft">
            <strong>Mobile Carrier Primary:</strong>
          </div>
          <div className="col-md-8">
            <select
              className="form-control devicesettingleft_select"
              name="mobile_carrier"
              value={devicesetting.mobile_carrier}
              onChange={inputEvent2}
            >
              <option value="">Select Mobile Carrier</option>
              {serviceProvider?.map((item, index) => (
                <option key={index + 1} value={item.mobile_provider_name}>
                  {item.mobile_provider_name}
                </option>
              ))}
            </select>
            {!devicesetting.mobile_carrier && (
              <span className="errormessage">
                <span>
                  <i className="fa fa-times errorifont" aria-hidden="true"></i>
                </span>
                Select your mobile carrier
              </span>
            )}
          </div>
        </div>
        <div className="row marginrow">
          <div className="col-md-4 textalignleft">
            <strong>Alert SMS/Text Primary:</strong>
          </div>
          <div className="col-md-8">
            <input
              name="phone"
              value={devicesetting.phone}
              onChange={inputEvent2}
              type="text"
              placeholder="Leave blank to disable"
              className="form-control devicesettingleft_text"
            />
            <p className="marginp devicesettingpfooter">
              ✱ Phone should be 10 digit without country code and hyphen!
            </p>
            <p className="phone_instruction2">
              * By providing your phone number, you are opting in to receive SMS
              alerts from{" "}
              <a
                target="_blank"
                href="https://amcrestgps.net/terms/"
                rel="noreferrer"
                className="termslink"
              >
                amcrestgps.net.
              </a>
            </p>
          </div>
        </div>
        {!secondarynumber ? (
          <div className="row marginrow">
            <div className="col-md-5 textalignleft">
              <strong>Alert SMS/Text Secondary:</strong>
            </div>
            <div className="col-md-7">
              <button
                className="btn"
                style={{ backgroundColor: "#3f51b5", color: "white" }}
                onClick={checksecondarynumber}
              >
                + Add Secondary Phone Number
              </button>
            </div>
          </div>
        ) : (
          <>
            <div className="row marginrow">
              <div className="col-md-4 textalignleft">
                <strong>Mobile Carrier Secondary:</strong>
              </div>
              <div className="col-md-8">
                <select
                  name="secondary_mobile_carrier"
                  value={devicesetting.secondary_mobile_carrier}
                  onChange={inputEvent2}
                  className="form-control devicesettingleft_select"
                >
                  <option value="">Select Mobile Carrier</option>
                  {serviceProvider?.map((item, index) => (
                    <option key={index + 1} value={item.mobile_provider_name}>
                      {item.mobile_provider_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row marginrow">
              <div className="col-md-4 textalignleft">
                <strong>Alert SMS/Text Secondary:</strong>
              </div>
              <div className="col-md-8">
                <input
                  name="secondary_phone"
                  value={devicesetting.secondary_phone}
                  onChange={inputEvent2}
                  type="text"
                  placeholder="Leave blank to disable"
                  className="form-control devicesettingleft_text"
                />
              </div>
            </div>
          </>
        )}
        {secondaryerror && (
          <span className="upgradeplantext" onClick={updateplan}>
            Upgrade your plan to enable secondary phone number !
          </span>
        )}
      </div>
      <hr className="devicesetting_margin" />
      <div>
        <div className="devicesetting_alert">
          <p>
            <strong>All Alerts:</strong>
          </p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={(e) => changeglobalsetting(e)}
              checked={globalalert}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>All Push Notification Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={(e) => changeglobalnotification(e)}
              checked={devicesetting.global_notification}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>All Email Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={(e) => changeglobalemail(e)}
              checked={devicesetting.global_email}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>All SMS/Text Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={(e) => changeglobalsms(e)}
              checked={devicesetting.global_sms}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
      </div>
      <hr className="devicesetting_margin" />
      <div>
        <div className="devicesetting_alert">
          <p>
            <strong>Speed Alerts:</strong>
          </p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={(e) => changeglobalspeed(e)}
              checked={devicesetting.speed_notification_global}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Speed Push Notification:</p>
          <label className="toggleswitch">
            <input
              onChange={inputEvent}
              name="speed_notification"
              type="checkbox"
              checked={devicesetting.speed_notification}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Speed Email Alerts:</p>
          <label className="toggleswitch">
            <input
              onChange={inputEvent}
              name="speed_email"
              type="checkbox"
              checked={devicesetting.speed_email}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Speed SMS/Text Alerts:</p>
          <label className="toggleswitch">
            <input
              onChange={inputEvent}
              name="speed_sms"
              type="checkbox"
              checked={devicesetting.speed_sms}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p style={{ flex: ".3" }}>Speed Limit:</p>
          <Slider
            style={{ flex: ".7", marginRight: "10px" }}
            value={speedvalue || ""}
            valueLabelDisplay="on"
            getAriaValueText={valuetext}
            aria-labelledby="discrete-slider-custom"
            onChange={handleChange}
            max={300}
            marks={marks}
          />
        </div>
      </div>
      <hr className="devicesetting_margin" />
      <div>
        <div className="devicesetting_alert">
          <p>
            <strong>Engine On/Off Alerts:</strong>
          </p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={(e) => changeglobalengine(e)}
              checked={devicesetting.engine_notification_global}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Engine On/Off Push Notification:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="engine_notification"
              checked={devicesetting.engine_notification}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Engine On/Off Email Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="engine_email"
              checked={devicesetting.engine_email}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Engine On/Off SMS/Text Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="engine_sms"
              checked={devicesetting.engine_sms}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
      </div>
      <hr className="devicesetting_margin" />
      <div>
        <div className="devicesetting_alert">
          <p>
            <strong>Harsh Behaviour Alerts:</strong>
          </p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={(e) => changeglobalharsh(e)}
              checked={devicesetting.harsh_notification_global}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Harsh Braking Push Notification:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="harshbraking_notification"
              checked={devicesetting.harshbraking_notification}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Harsh Braking Email Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="harshbraking_email"
              checked={devicesetting.harshbraking_email}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Harsh Braking SMS/Text Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="harshbraking_sms"
              checked={devicesetting.harshbraking_sms}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Harsh Turning Push Notification:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="harshturning_notification"
              checked={devicesetting.harshturning_notification}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Harsh Turning Email Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="harshturning_email"
              checked={devicesetting.harshturning_email}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Harsh Turning SMS/Text Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="harshturning_sms"
              checked={devicesetting.harshturning_sms}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Harsh Acceleration Push Notification:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="harshacceleration_notification"
              checked={devicesetting.harshacceleration_notification}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Harsh Acceleration Email Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="harshacceleration_email"
              checked={devicesetting.harshacceleration_email}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Harsh Acceleration SMS/Text Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="harshacceleration_sms"
              checked={devicesetting.harshacceleration_sms}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <fieldset style={{ borderTop: "1px solid #ccc" }}>
          <legend
            style={{ fontSize: "17px" }}
            className="ml-2 mb-0 width_fitcontent"
          >
            <strong>Basic Settings</strong>
          </legend>
        </fieldset>
        <div className="row devicesettingleft">
          <div className="col-md-6 pr-0">
            <div>
              <fieldset
                style={{
                  border: "1px solid #ccc",
                  padding: "0 10px",
                  borderRadius: "10px",
                  paddingBottom: "10px",
                }}
              >
                <legend
                  className="width_fitcontent"
                  style={{
                    fontSize: "17px",
                  }}
                >
                  <strong>High Speed</strong>
                </legend>
                <div className="row" style={{ marginBottom: "5px" }}>
                  <div className="col-sm-3">
                    <label style={{ fontWeight: 400 }}>Speed:</label>
                  </div>
                  <div className="col-sm-6 p-0 obdsetting_input">
                    <input
                      type="number"
                      className="form-control devicesettingleft_text"
                      placeholder="Enter Value"
                      id="high_speed"
                      value={devicesetting.high_speed}
                      onChange={handleharshaccelerationchange}
                    />
                  </div>
                  <div className="col-sm-2 p-0 d-flex align-items-center">
                    <label style={{ fontWeight: 400 }}>
                      {activationType.unit === "MPH" ? "Mph" : "Kph"}
                    </label>
                  </div>
                </div>
                <div className="row" style={{ marginBottom: "5px" }}>
                  <div className="col-sm-3">
                    <label style={{ fontWeight: 400 }}>&Delta;Vhb:</label>
                  </div>
                  <div className="col-sm-6 p-0 obdsetting_input">
                    <input
                      type="number"
                      className="form-control devicesettingleft_text"
                      placeholder="Enter Value"
                      id="high_speed_breaking"
                      value={devicesetting.high_speed_breaking}
                      onChange={handleharshaccelerationchange}
                    />
                  </div>
                  <div className="col-sm-2 p-0 d-flex align-items-center">
                    <label style={{ fontWeight: 400 }}>
                      {activationType.unit === "MPH" ? "Mph" : "Kph"}
                    </label>
                  </div>
                </div>
                <div className="row" style={{ marginBottom: "5px" }}>
                  <div className="col-sm-3">
                    <label style={{ fontWeight: 400 }}>&Delta;Vha:</label>
                  </div>
                  <div className="col-sm-6 p-0 obdsetting_input">
                    <input
                      type="number"
                      className="form-control devicesettingleft_text"
                      placeholder="Enter Value"
                      id="high_speed_acceleration"
                      value={devicesetting.high_speed_acceleration}
                      onChange={handleharshaccelerationchange}
                    />
                  </div>
                  <div className="col-sm-2 p-0 d-flex align-items-center">
                    <label style={{ fontWeight: 400 }}>
                      {activationType.unit === "MPH" ? "Mph" : "Kph"}
                    </label>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          <div className="col-md-6">
            <div>
              <fieldset
                style={{
                  border: "1px solid #ccc",
                  padding: "0 10px",
                  borderRadius: "10px",
                  paddingBottom: "10px",
                }}
              >
                <legend
                  className="width_fitcontent"
                  style={{
                    fontSize: "17px",
                  }}
                >
                  <strong> Middle Speed</strong>
                </legend>
                <div className="row" style={{ marginBottom: "5px" }}>
                  <div className="col-sm-3">
                    <label style={{ fontWeight: 400 }}>Speed:</label>
                  </div>
                  <div className="col-sm-6 p-0 obdsetting_input">
                    <input
                      type="number"
                      className="form-control devicesettingleft_text"
                      placeholder="Enter Value"
                      id="medium_speed"
                      value={devicesetting.medium_speed}
                      onChange={handleharshaccelerationchange}
                    />
                  </div>
                  <div className="col-sm-2 p-0 d-flex align-items-center">
                    <label style={{ fontWeight: 400 }}>
                      {activationType.unit === "MPH" ? "Mph" : "Kph"}
                    </label>
                  </div>
                </div>
                <div className="row" style={{ marginBottom: "5px" }}>
                  <div className="col-sm-3">
                    <label sstyle={{ fontWeight: 400 }}>&Delta;Vmb:</label>
                  </div>
                  <div className="col-sm-6 p-0 obdsetting_input">
                    <input
                      type="number"
                      className="form-control devicesettingleft_text"
                      placeholder="Enter Value"
                      id="medium_speed_breaking"
                      value={devicesetting.medium_speed_breaking}
                      onChange={handleharshaccelerationchange}
                    />
                  </div>
                  <div className="col-sm-2 p-0 d-flex align-items-center">
                    <label style={{ fontWeight: 400 }}>
                      {activationType.unit === "MPH" ? "Mph" : "Kph"}
                    </label>
                  </div>
                </div>
                <div className="row" style={{ marginBottom: "5px" }}>
                  <div className="col-sm-3">
                    <label style={{ fontWeight: 400 }}>&Delta;Vma:</label>
                  </div>
                  <div className="col-sm-6 p-0 obdsetting_input">
                    <input
                      type="number"
                      className="form-control devicesettingleft_text"
                      placeholder="Enter Value"
                      id="medium_speed_acceleration"
                      value={devicesetting.medium_speed_acceleration}
                      onChange={handleharshaccelerationchange}
                    />
                  </div>
                  <div className="col-sm-2 p-0 d-flex align-items-center">
                    <label style={{ fontWeight: 400 }}>
                      {activationType.unit === "MPH" ? "Mph" : "Kph"}
                    </label>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <div className="row devicesettingleft">
          <div className="col-md-6 pr-0">
            <div>
              <fieldset
                style={{
                  border: "1px solid #ccc",
                  padding: "0 10px",
                  borderRadius: "10px",
                  paddingBottom: "10px",
                }}
              >
                <legend
                  className="width_fitcontent"
                  style={{
                    fontSize: "17px",
                  }}
                >
                  <strong> Low Speed</strong>
                </legend>
                <div className="row" style={{ marginBottom: "5px" }}>
                  <div className="col-sm-3">
                    <label style={{ fontWeight: 400 }}>&Delta;Vlb:</label>
                  </div>
                  <div className="col-sm-6 p-0 obdsetting_input">
                    <input
                      type="number"
                      className="form-control devicesettingleft_text"
                      placeholder="Enter Value"
                      id="low_speed_braking"
                      value={devicesetting.low_speed_braking}
                      onChange={handleharshaccelerationchange}
                    />
                  </div>
                  <div className="col-sm-2 p-0 d-flex align-items-center">
                    <label style={{ fontWeight: 400 }}>
                      {activationType.unit === "MPH" ? "Mph" : "Kph"}
                    </label>
                  </div>
                </div>
                <div className="row" style={{ marginBottom: "5px" }}>
                  <div className="col-sm-3">
                    <label style={{ fontWeight: 400 }}>&Delta;Vla:</label>
                  </div>
                  <div className="col-sm-6 p-0 obdsetting_input">
                    <input
                      type="number"
                      className="form-control devicesettingleft_text"
                      placeholder="Enter Value"
                      id="low_speed_acceleration"
                      value={devicesetting.low_speed_acceleration}
                      onChange={handleharshaccelerationchange}
                    />
                  </div>
                  <div className="col-sm-2 p-0 d-flex align-items-center">
                    <label style={{ fontWeight: 400 }}>
                      {activationType.unit === "MPH" ? "Mph" : "Kph"}
                    </label>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <fieldset style={{ borderTop: "1px solid #ccc" }}>
          <legend
            style={{ fontSize: "17px" }}
            className="ml-2 mb-0 width_fitcontent"
          >
            <strong>Other Settings</strong>
          </legend>
        </fieldset>
        <div className="form-group obdsetting_input devicesettingleft">
          <div className="row">
            <label
              className="col-md-6 px-0 minwidth_label"
              style={{ fontWeight: 400 }}
            >
              Cornering and Braking Threshold:
            </label>
            <div className="col-md-6 px-0">
              <input
                type="number"
                className="form-control devicesettingleft_text"
                placeholder="Enter Value"
                id="corner_braking_thershold"
                value={devicesetting.corner_braking_thershold}
                onChange={handleharshaccelerationchange}
              />
            </div>
          </div>
        </div>
        <div className="form-group obdsetting_input devicesettingleft">
          <div className="row">
            <label className="col-md-6 px-0" style={{ fontWeight: 400 }}>
              Cornering and Braking Duration:
            </label>
            <div className="col-md-6 row px-0">
              <input
                type="number"
                className="col-md-10 form-control devicesettingleft_text"
                placeholder="Enter Value"
                id="corner_braking_duration"
                value={devicesetting.corner_braking_duration}
                onChange={handleharshaccelerationchange}
              />
              <span className="col-md-2 d-flex align-items-center">*8ms</span>
            </div>
          </div>
        </div>
        <div className="form-group obdsetting_input devicesettingleft">
          <div className="row">
            <label className="col-md-6 px-0" style={{ fontWeight: 400 }}>
              Acceleration Threshold:
            </label>
            <div className="col-md-6 px-0">
              <input
                type="number"
                className="form-control devicesettingleft_text"
                placeholder="Enter Value"
                id="acceleration_thershold"
                value={devicesetting.acceleration_thershold}
                onChange={handleharshaccelerationchange}
              />
            </div>
          </div>
        </div>
        <div className="form-group obdsetting_input devicesettingleft">
          <div className="row">
            <label className="col-md-6 px-0" style={{ fontWeight: 400 }}>
              Acceleration Duration:
            </label>
            <div className="col-md-6 px-0 row">
              <input
                type="number"
                className="col-md-10 form-control devicesettingleft_text"
                placeholder="Enter Value"
                id="acceleration_duration"
                value={devicesetting.acceleration_duration}
                onChange={handleharshaccelerationchange}
              />
              <span className="col-md-2 d-flex align-items-center">*8ms</span>
            </div>
          </div>
        </div>
        {harsherror && (
          <span className="upgradeplantext" onClick={updateplan}>
            Upgrade your plan to enable Harsh Behaviour Alert !
          </span>
        )}
      </div>
      <hr className="devicesetting_margin" />
      <div>
        <div className="devicesetting_alert">
          <p>
            <strong>Crash Detection and Acceleration Report Alerts:</strong>
          </p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={(e) => changeglobalcrash(e)}
              checked={devicesetting.crash_acceleration_notification_global}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Crash & Acceleration Push Notification:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="crash_acceleration_notification"
              checked={devicesetting.crash_acceleration_notification}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Crash & Acceleration Email Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="crash_acceleration_email"
              checked={devicesetting.crash_acceleration_email}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Crash & Acceleration SMS/Text Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="crash_acceleration_sms"
              checked={devicesetting.crash_acceleration_sms}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <fieldset style={{ borderTop: "1px solid #ccc" }}>
          <legend
            style={{ fontSize: "17px" }}
            className="ml-2 mb-0 width_fitcontent"
          >
            <strong>Basic Settings</strong>
          </legend>
        </fieldset>
        <div className="form-group obdsetting_input devicesettingleft">
          <div className="row">
            <label
              className="col-md-6 px-0 minwidth_label"
              style={{ fontWeight: 400 }}
            >
              Threshold_X:
            </label>
            <div className="col-md-6 px-0">
              <input
                type="number"
                className="form-control devicesettingleft_text"
                placeholder="Enter Value"
                id="threshold_x"
                value={devicesetting.threshold_x}
                onChange={handlecrashdetectionchange}
              />
            </div>
          </div>
        </div>
        <div className="form-group obdsetting_input devicesettingleft">
          <div className="row">
            <label
              className="col-md-6 px-0 minwidth_label"
              style={{ fontWeight: 400 }}
            >
              Threshold_Y:
            </label>
            <div className="col-md-6 px-0">
              <input
                type="number"
                className="form-control devicesettingleft_text"
                placeholder="Enter Value"
                id="threshold_y"
                value={devicesetting.threshold_y}
                onChange={handlecrashdetectionchange}
              />
            </div>
          </div>
        </div>
        <div className="form-group obdsetting_input devicesettingleft">
          <div className="row">
            <label
              className="col-md-6 px-0 minwidth_label"
              style={{ fontWeight: 400 }}
            >
              Threshold_Z:
            </label>
            <div className="col-md-6 px-0">
              <input
                type="number"
                className="form-control devicesettingleft_text"
                placeholder="Enter Value"
                id="threshold_z"
                value={devicesetting.threshold_z}
                onChange={handlecrashdetectionchange}
              />
            </div>
          </div>
        </div>
        <div className="form-group obdsetting_input devicesettingleft">
          <div className="row">
            <label
              className="col-md-6 px-0 minwidth_label"
              style={{ fontWeight: 400 }}
            >
              Samples before crash:
            </label>
            <div className="col-md-6 px-0">
              <input
                type="number"
                className="form-control devicesettingleft_text"
                placeholder="Enter Value"
                id="samples_after_crash"
                value={devicesetting.samples_after_crash}
                onChange={handlecrashdetectionchange}
              />
            </div>
          </div>
        </div>
        <div className="form-group obdsetting_input devicesettingleft">
          <div className="row">
            <label
              className="col-md-6 px-0 minwidth_label"
              style={{ fontWeight: 400 }}
            >
              Samples after crash:
            </label>
            <div className="col-md-6 px-0">
              <input
                type="number"
                className="form-control devicesettingleft_text"
                placeholder="Enter Value"
                id="samples_before_crash"
                value={devicesetting.samples_before_crash}
                onChange={handlecrashdetectionchange}
              />
            </div>
          </div>
        </div>
        {crasherror && (
          <span className="upgradeplantext" onClick={updateplan}>
            Upgrade your plan to enable Crash Detection Alert !
          </span>
        )}
      </div>
      <hr className="devicesetting_margin" />
      <div>
        <div className="devicesetting_alert">
          <p>
            <strong>Attach/Dettach Alerts:</strong>
          </p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={(e) => changeglobalattach(e)}
              checked={devicesetting.attach_dettach_notification_global}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Attach/Dettach Push Notification:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="attach_dettach_notification"
              checked={devicesetting.attach_dettach_notification}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Attach/Dettach Email Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="attach_dettach_email"
              checked={devicesetting.attach_dettach_email}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Attach/Dettach SMS/Text Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="attach_dettach_sms"
              checked={devicesetting.attach_dettach_sms}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
      </div>
      <hr className="devicesetting_margin" />
      <div>
        <div className="devicesetting_alert">
          <p>
            <strong>Towing Alerts:</strong>
          </p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={(e) => changeglobaltow(e)}
              checked={devicesetting.tow_notification_global}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Towing Push Notification:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="tow_notification"
              checked={devicesetting.tow_notification}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Towing Email Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="tow_email"
              checked={devicesetting.tow_email}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Towing SMS/Text Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="tow_sms"
              checked={devicesetting.tow_sms}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        {towingerror && (
          <span className="upgradeplantext" onClick={updateplan}>
            Upgrade your plan to enable Towing Alert !
          </span>
        )}
      </div>
      <hr className="devicesetting_margin" />
      <div>
        <div className="devicesetting_alert">
          <p>
            <strong>Warning/Emission Alerts:</strong>
          </p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={(e) => changeglobalwarning(e)}
              checked={devicesetting.warning_notification_global}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Warning/Emission Push Notification:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="warning_notification"
              checked={devicesetting.warning_notification}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Warning/Emission Email Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="warning_email"
              checked={devicesetting.warning_email}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Warning/Emission SMS/Text Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="warning_sms"
              checked={devicesetting.warning_sms}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
      </div>
      <hr className="devicesetting_margin" />
      <div className="devicesettingleft">
        <div className="row marginrow">
          <div className="col-md-4 textalignleft">
            <strong>Trip End Meter:</strong>
          </div>
          <div className="col-md-8">
            <Slider
              value={tripvalue || ""}
              valueLabelDisplay="on"
              getAriaValueText={valuetext2}
              aria-labelledby="discrete-slider-custom"
              onChange={handletripChange}
              max={10}
              marks={marks2}
            />
          </div>
        </div>
      </div>
      <hr className="devicesetting_margin" />
      <div className="devicesettingleft">
        <div className="row marginrow">
          <div className="col-md-4 textalignleft">
            <strong>Fuel Tank Capacity:</strong>
          </div>
          <div className="col-md-8 devicesetting_fueldisplay">
            <input
              type="text"
              name="fuel_capacity"
              value={devicesetting.fuel_capacity}
              onChange={inputEvent2}
              placeholder="Enter Fuel Tank Capacity"
              className="form-control devicesettingleft_text"
            />
            <select
              name="fuel_capacity_unit"
              value={devicesetting.fuel_capacity_unit}
              onChange={inputEvent2}
              className="fuelcapacitydropdown"
            >
              <option value="gallon">Gallon</option>
              <option value="liter">Litre</option>
            </select>
          </div>
        </div>
      </div>
      <hr className="devicesetting_margin" />
      <div className="devicesettingleft">
        <div className="row marginrow">
          <div className="col-md-4 textalignleft">
            <strong>Update Odometer:</strong>
          </div>
          <div className="col-md-8 devicesetting_fueldisplay">
            <input
              type="text"
              value={devicesetting.odometer_value}
              onChange={changeOdometer}
              placeholder="Enter Odometer Value"
              className="form-control devicesettingleft_text"
            />
            <p style={{ fontWeight: "600" }} className="marginp">
              {activationType.unit === "MPH" ? "Miles" : activationType.unit}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeviceSettingOBDLeft;
